import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.admin');
import { OnInit, DoCheck } from '@angular/core';
import { Router } from '@angular/router';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-admin',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.admin/view.scss */
/* src/app/page.admin/view.scss: no such file or directory */`],
})
export class PageAdminComponent implements OnInit, DoCheck {
    constructor(@Inject( Service) public service: Service,@Inject( Router)  private router: Router) { }
    public main = '';
    public sub = '';
    public id = '';
    public menu = '';
    private ready = false;
    private redirecting = false;

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow.membership('admin', '/');
        this.ready = true;
        this.syncRoute();
        await this.service.render();
    }

    public ngDoCheck() { if (this.ready) this.syncRoute(); }

    private syncRoute() {
        const segments = this.router.url.split(/[?#]/)[0].split('/').filter(Boolean).map(decodeURIComponent);
        if (segments[0] !== 'admin') return;
        const session = this.service.auth.session;
        const [, main = '', sub = '', id = '', menu = ''] = segments;
        const isAdmin = session?.role === 'admin';
        const denied = !isAdmin && ((main === 'community' && sub !== session?.community_id)
            || ['users', 'password', 'logs'].includes(main));
        if (!main || denied) {
            this.main = '';
            if (!this.redirecting) {
                this.redirecting = true;
                const target = isAdmin ? '/admin/community' : session?.community_id
                    ? '/admin/community/' + encodeURIComponent(session.community_id) + '/info' : '/dashboard';
                Promise.resolve().then(() => this.router.navigateByUrl(target, {replaceUrl: true}))
                    .finally(() => this.redirecting = false);
            }
            return;
        }
        this.main = main; this.sub = sub; this.id = id; this.menu = menu;
    }
}

export default PageAdminComponent;